<template>
  <div class="detail-dialog">
    <el-collapse v-model="activeNames" class="collapse-wrap">
      <el-collapse-item
        v-for="(group, index) in groups"
        :key="index"
        :title="group.name"
        :name="group.tempId"
        :class="{ 'hide-last2': !(group.fields.length % 2) }"
      >
        <field-item
          v-for="(field, index) in group.fields"
          :key="index"
          :field="field"
          :value="dataMap[field.id]"
          :empty-text="group.emptyText"
          :control="field.control"
          :is-overdue="isOverdue"
        ></field-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { basicInfo, systemInfo } from "./static"
import FieldItem from "./FieldItem"
import dj from "dayjs"
import { getRefDataInfo } from "@/utils/task"

export default {
  name: "data-detail",
  components: {
    FieldItem
  },
  data() {
    return {
      activeNames: [],
      refDataInfo: null,
      dataInfo: { dataId: "" }
    }
  },
  props: {
    taskInfo: {
      type: Object,
      default: () => ({})
    },
    sheetDef: Object
  },
  provide() {
    return { dataInfo: this.dataInfo }
  },
  computed: {
    groups() {
      let displayBasicInfo = Object.assign({}, basicInfo, {
        fields: basicInfo.fields.filter(i => {
          return !(i.id == "parentTask" && !this.taskInfo.parentId)
        })
      })
      if (this.taskInfo.overDueReason) {
        displayBasicInfo.fields.push(
          {
            name: "逾期原因",
            id: "overDueReason"
          },
          {
            name: "逾期备注",
            id: "overDueRemark"
          }
        )
      }
      if (this.taskInfo.riskSet) {
        displayBasicInfo.fields = displayBasicInfo.fields.filter(
          field => field.name !== "任务优先级"
        )
        displayBasicInfo.fields.push(
          {
            name: "风险等级",
            id: "riskLevel"
          },
          {
            name: "应对方案",
            id: "copingPlan"
          }
        )
      }
      if (!this.refDataInfo) return [displayBasicInfo, systemInfo]
      return [displayBasicInfo, this.refDataInfo, systemInfo]
    },
    sheetDataMap() {
      let sheetDataMap = {}
      if (!this.refDataInfo) return sheetDataMap
      for (let field of this.refDataInfo.fields) {
        if (["file", "ref", "rich"].includes(field._type))
          sheetDataMap[field.id] = this.taskInfo.sheetData?.data?.[field.id]
        else sheetDataMap[field.id] = this.taskInfo.sheetData?.dataForShow?.[field.id]
      }
      return sheetDataMap
    },
    dataMap() {
      if (!this.taskInfo) return {}
      let basicData = {
        // type: "",
        path: this.taskInfo.path,
        name: this.taskInfo.name,
        leader: this.taskInfo.assigneeUser,
        assigneeRole: this.taskInfo.assignProjectRole?.name,
        startAt: this.taskInfo.startAt ? dj(this.taskInfo.startAt).format("YYYY-MM-DD") : "",
        dueDate: this.taskInfo.dueDate ? dj(this.taskInfo.dueDate).format("YYYY-MM-DD") : "",
        taskType: this.taskInfo.taskType?.name,
        status: this.taskInfo.status,
        priority: this.taskInfo.priorityStr,
        remark: this.taskInfo.description,
        parentTask: this.taskInfo.parentId ? this.taskInfo.parentTask : {},
        attachments: this.taskInfo.attachments ? this.taskInfo.attachments : [],
        overDueReason: this.taskInfo?.overDueReason,
        overDueRemark: this.taskInfo?.overDueRemark,
        copingPlan: this.taskInfo?.copingPlan,
        riskLevel:
          this.taskInfo?.riskLevel === 1
            ? "低"
            : this.taskInfo?.riskLevel === 2
            ? "中"
            : this.taskInfo?.riskLevel === 3
            ? "高"
            : ""
      }
      let systemData = {
        createAt: this.taskInfo.createAt,
        creator: this.taskInfo.creator,
        completeUser: this.taskInfo.completerUser,
        completeAt: this.taskInfo.completeAt,
        verifyAt:
          this.taskInfo.status == "已完成" ? this.taskInfo.verifyAt || this.taskInfo.completeAt : ""
      }
      if (!this.refDataInfo) return { ...basicData, ...systemData }
      return { ...basicData, ...systemData, ...this.sheetDataMap }
    },
    isOverdue() {
      if (this.taskInfo.completeAt && this.taskInfo.dueDate) {
        if (dj(this.taskInfo.dueDate).isBefore(dj(this.taskInfo.completeAt))) {
          let days = dj(this.taskInfo.completeAt).diff(this.taskInfo.dueDate, "day")
          if (days === 0) return { status: false }
          return {
            status: true,
            days: days
          }
        }
      } else if (dj(this.taskInfo.dueDate).isBefore(dj())) {
        let days = dj().diff(this.taskInfo.dueDate, "day")
        if (days === 0) return { status: false }
        return {
          status: true,
          days: days
        }
      }
      return { status: false }
    }
  },
  methods: {
    init() {
      this.refDataInfo = getRefDataInfo(this.taskInfo, this.sheetDef)
      this.activeNames = this.groups.map(group => group.tempId)
      Object.assign(this.dataInfo, { dataId: this.taskInfo.id })
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse-wrap {
  margin: 0 32px 70px 0;
  border-top: none;
  ::v-deep {
    .el-collapse-item {
      border-bottom: 1px solid #e4e4e4;
      &.hide-last2 .field-item:nth-last-child(2) {
        border-bottom: none;
      }
    }
    .el-collapse-item + .el-collapse-item {
      margin-top: 10px;
    }
    .el-collapse-item.is-active + .el-collapse-item {
      margin-top: 20px;
    }
    .el-collapse-item__header,
    .el-collapse-item__wrap {
      border-bottom: none;
    }
    .el-collapse-item__header,
    .el-collapse-item__content {
      color: $color-font-title;
    }
    .el-collapse-item__header {
      height: 30px;
      line-height: 30px;
      font-size: $font-size-main;
      font-weight: bold;
      .el-collapse-item__arrow {
        margin-left: 10px;
        color: $color-font-second;
      }
    }
    .el-collapse-item__content {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 0;
      .field-item {
        width: 50%;
        box-sizing: border-box;
        &:not(:last-child) {
          border-bottom: 1px solid #e4e4e4;
        }

        &:nth-child(odd) {
          padding-right: 30px;
        }
        &:nth-child(even) {
          padding-left: 30px;
        }
      }
    }
  }
}
</style>
